/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExternalDocumentTypeDirectory } from '../../models/external-document-type-directory';

export interface GetDocumentTypeDirectoryByCustomer$Params {
  customerGUID: string;
}

export function getDocumentTypeDirectoryByCustomer(http: HttpClient, rootUrl: string, params: GetDocumentTypeDirectoryByCustomer$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ExternalDocumentTypeDirectory>>> {
  const rb = new RequestBuilder(rootUrl, getDocumentTypeDirectoryByCustomer.PATH, 'get');
  if (params) {
    rb.path('customerGUID', params.customerGUID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ExternalDocumentTypeDirectory>>;
    })
  );
}

getDocumentTypeDirectoryByCustomer.PATH = '/external-document/type-directories/customers/{customerGUID}';
